// 各货币兑人民币汇率
export const ExchangeRateToCNYMap: Record<string, number> = {
  'CNY': 1,
  'EUR': 7.7056,
  'USD': 7.1783,
  'AUD': 4.7227,
  'CAD': 5.15,
  'GBP': 9.2518,
  'HKD': 0.92302,
  'JPY': 0.04645,
  'KRW': 0.00513,
  'SGD': 5.3835,
  'TWD': 0.2221,
};

// 默认币种
export const DEFAULT_CURRENCY = 'CNY';
